"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.radioButtonDocumentWithOldDSResponse = void 0;
var radioButtonDocument_1 = require("./radioButtonDocument");
exports.radioButtonDocumentWithOldDSResponse = __assign(__assign({}, radioButtonDocument_1.radioButtonDocument), { responses: [
        {
            answer: "Cherry",
            questionId: 1195202,
            questionRootId: 1195202,
            associatedId: 1190000,
            timeAnswered: "",
        },
    ] });
//# sourceMappingURL=radioButtonDocumentWithOldDSResponse.js.map